import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
	// mode: 'history',
	routes: [
		{path: '/project', name: 'project'},
		{path: '/*', name: 'main'},

	],
	linkActiveClass: "active",
	linkExactActiveClass: "active"
})
